export const extractIframeSrc = (input: string): string | null => {
  const trimmed = input.trim();

  const iframeMatch = trimmed.match(
    /<iframe\b[^>]*\bsrc\s*=\s*["']([^"']+)["'][^>]*>/i,
  );
  if (iframeMatch?.[1]) return iframeMatch[1];

  const srcMatch = trimmed.match(/src\s*=\s*["']([^"']+)["']/i);
  if (srcMatch?.[1]) return srcMatch[1];

  return null;
};
